module.exports = __webpack_public_path__ + "img/logoAskia.7bccf0fd.png";